import cn from '@/lib/cs';
import React from 'react';

const DeleteIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="m20.4 7.7.6-.9-.5-.6V6l-.3.2-1-2-2.4-1h-2.2L14.2 2l-.4.3h-3.5l-.7.6v.4L7.3 3 5.2 4.5 3.8 6v.2L3 7l.7.8m.7 1.5.8 5 .4 5.1L8.3 22l3.8-.2 3.7.3 2.7-2.7.6-5 .7-5.2-5.2.3h-5l-5.2-.2Z"
		/>
	</svg>
);

export default DeleteIcon;
